import {USER_PROFILE_PREVIEW_QUERY_PARAM} from '../../imports/user-profile-types.js'
import {USER_PROFILE_PATH_SEGMENT} from '../../imports/space-path.js'
import {normalizeUsernameInput} from './username-format.js'

/** First URL segment for public user profiles (`/u/@handle`). */
export {USER_PROFILE_PATH_SEGMENT}

const USER_PROFILE_PATH_PATTERN = new RegExp(`^/${USER_PROFILE_PATH_SEGMENT}/([^/]+)/?$`)

export const parseUserProfileUsernameFromPathname = (pathname: string): string | null => {
	const match = pathname.replace(/\/+$/, '').match(USER_PROFILE_PATH_PATTERN)
	if (!match?.[1]) return null
	const normalized = normalizeUsernameInput(decodeURIComponent(match[1]))
	return normalized || null
}

export const isUserProfilePathname = (pathname: string): boolean =>
	parseUserProfileUsernameFromPathname(pathname) !== null

export const buildUserProfilePath = (username: string): string => {
	const normalized = normalizeUsernameInput(username)
	if (!normalized) return `/${USER_PROFILE_PATH_SEGMENT}`
	return `/${USER_PROFILE_PATH_SEGMENT}/${encodeURIComponent(normalized)}`
}

export const setUserProfilePreviewInUrl = (enabled: boolean) => {
	const current = new URL(location.href)
	if (enabled) current.searchParams.set(USER_PROFILE_PREVIEW_QUERY_PARAM, '1')
	else current.searchParams.delete(USER_PROFILE_PREVIEW_QUERY_PARAM)

	if (enabled) history.pushState({}, '', current.href)
	else history.replaceState({}, '', current.href)
}
